import { render, staticRenderFns } from "./CardCreate.vue?vue&type=template&id=55afc7ea&scoped=true&"
import script from "./CardCreate.vue?vue&type=script&lang=js&"
export * from "./CardCreate.vue?vue&type=script&lang=js&"
import style0 from "./CardCreate.vue?vue&type=style&index=0&id=55afc7ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55afc7ea",
  null
  
)

export default component.exports